import { Construction } from 'lucide-react';

/**
 * Fallback shown when the 3D siteview data cannot be loaded for a site.
 * Typically occurs when a customer is onboarded but a specific site
 * has not yet completed siteview setup.
 */
export function FallbackSiteUnavailable() {
  return (
    <div className="flex size-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 p-8 text-center">
      <Construction className="mb-4 size-12 text-gray-400" aria-hidden="true" />
      <h2 className="mb-2 text-xl font-semibold text-gray-700">
        3D View Not Available
      </h2>
      <div className="max-w-md space-y-2 text-gray-500">
        <p>
          The 3D siteview for this site is currently being set up and is not yet
          available.
        </p>
        <p>
          Please check back later or contact your customer success manager for
          more information.
        </p>
      </div>
    </div>
  );
}
